import React, {Component} from "react";
import ReactMapGL from "react-map-gl";

import "mapbox-gl/dist/mapbox-gl.css";
import FactsContainer from "./facts";
import Timeline from "./timeline";
import styles from "./maptimeline.module.css";

class TimelineFacts extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      viewport: {
        height: this.clientHeight,
        width: this.clientWidth,
        latitude: 43.646540,
        longitude: -79.384749,
        zoom: 14
      }
    };
  }

  get clientHeight() {
    return this.clientWidth < 750
      ? 500
      : 296
  }

  goToCity = (latitude, longitude) => this._onViewportChange({latitude: latitude, longitude: longitude});

  componentDidMount() {
    this.goToCity = this.goToCity.bind(this);
    this.clientWidth = document.documentElement.clientWidth;
    window.addEventListener("resize", this._resize);
    this._resize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._resize);
  }

  _onViewportChange = viewport => this.setState({
    viewport: {
      ...this.state.viewport,
      ...viewport
    }
  });

  _resize = () => this._onViewportChange({width: this.clientWidth, height: this.clientHeight});

  render() {
    return (<section className={styles.bottom}>
      <div className={styles.map}>
        <ReactMapGL {...this.state.viewport} onViewportChange={this._onViewportChange} mapboxApiAccessToken={process.env.MAPBOX_KEY} mapStyle="mapbox://styles/bdelo/cjdlyk9h710y42rqn7l9rld0g" attributionControl={false}/>
      </div>
      <div className={styles.wrapper}>
        <Timeline hoverHandler={this.goToCity}/>
        <FactsContainer/>
      </div>
    </section>);
  }
}

export default TimelineFacts;



// WEBPACK FOOTER //
// ./src/components/maptimeline.js